import PillEditor from "Shared/components/PillEditor/PillEditor"
import BlockStyles from "../../BlockStyles"
import LiquidValidator from "Shared/components/LiquidValidator/LiquidValidator"

const ParagraphBlock = ({ block, active }) => {
  const act = useAct()
  const { mergeTags } = useSel(s => s.campaignBuilder)
  const updateText = (text) => act.email.blocks.updateParameters(block.id, { text })
  const mergeTagTests = useSel((s) => _.values(s.mergeTagTests.entities))
  
  const allMergeTags = () => {
    if (!mergeTagTests || mergeTagTests.length == 0) {
      return mergeTags;
    }
    return {...mergeTags, "Experiments": mergeTagTests.map(t => ({ label: t.name, slug: 'tests.' + t.slug, featured: false }))}; 
  }
  
  return (
    <div id={`block_${block.id}`}>
      {!active && <div dangerouslySetInnerHTML={{ __html: block.parameters.text }} />}
      {active && <>
        <PillEditor initialValue={block.parameters.text} onChange={updateText} richText availableTags={mergeTags} condensed />
        <LiquidValidator value={block.parameters.text} lineSplitTags={true} availableTags={allMergeTags()} />
      </>}

      <BlockStyles block={block} active={active} />
    </div>
  )
}

export default ParagraphBlock
